import { replace } from 'redux-first-history';
import { SagaIterator } from 'redux-saga';
import { loadProjectListFull } from 'src/modules/project-list/sagas/utils/loadProjectListFull';
import { getProjectSettings } from 'src/modules/project-view/selectors/getProjectSettings';
import { logDebug } from 'src/sagas/utils/logging';
import { call, cancel, put, select } from 'typed-redux-saga';

export function* returnToHome(): SagaIterator<void> {
  const projects = yield* call(loadProjectListFull);
  const [project] = projects;
  const settings = yield* select(getProjectSettings);
  if (settings.annualSaving === null) {
    yield* call(logDebug, 'Redirecting to first project...');
    yield* put(replace(`/project/${encodeURIComponent(project.id)}`));
    yield* cancel();
  }
}
